export default __webpack_public_path__ + "static/media/muenchen_dark.5e81ae58.png";